// extracted by mini-css-extract-plugin
export default {"noneOverlay":"Video_noneOverlay__-Yn35","defaultOverlay":"Video_defaultOverlay__bIZCL"};